import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import state from '../store/index.js'
import { getSetting } from '../api/index.js'
Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: "/about",
		name: "About",
		component: () => import('../views/About.vue'),
		meta: {
			title: "联系我们",
			auth: false
		}
	},
	{
		path: "/fashionshow",
		name: "FashionShow",
		component: () => import('../views/FashionShow.vue'),
		meta: {
			title: "服装展示",
			auth: false
		}
	},
	{
		path: "/category",
		name: "Category",
		component: () => import('../views/Category/Category.vue'),
		meta: {
			title: "私人定制",
			auth: false
		}
	},
	{
		path: "/categoryList",
		name: "CategoryList",
		component: () => import('../views/Category/CategoryList.vue'),
		meta: {
			title: "精品定制",
			auth: false
		}
	},
	{
		path: "/group_category",
		name: "GroupCategory",
		component: () => import('../views/Category/GroupCategory.vue'),
		meta: {
			title: "团体定制",
			auth: false
		}
	},
	{
		path: "/size_category_list",
		name: "SizeCategoryList",
		component: () => import('../views/Category/SizeCategoryList.vue'),
		meta: {
			title: "标码定制",
			auth: false
		}
	},
	{
		path: "/news",
		name: "News",
		component: () => import('../views/News/Index'),
		meta: {
			title: "新闻资讯",
			auth: false
		},
	},
	{
		path: "/detail",
		name: "Detail",
		component: () => import('../views/News/NewsDetail.vue'),
		meta: {
			title: "资讯详情",
			auth: false
		}
	},
	{
		path: "/checkout",
		name: "Checkout",
		component: () => import('../views/Checkout/Checkout.vue'),
		meta: {
			title: "确认订单",
			auth: true
		}
	},
	{
		path: "/figure",
		name: "Figure",
		component: () => import('../views/Figure/Figure.vue'),
		meta: {
			title: "量体",
			auth: true
		}
	},
	{
		path: "/group_figure",
		name: "GroupFigure",
		component: () => import('../views/Figure/GroupFigure.vue'),
		meta: {
			title: "团体量体",
			auth: true
		}
	},
	{
		path: "/design",
		name: "Design",
		component: () => import('../views/Design/Design.vue'),
		meta: {
			title: "私人定制",
			// auth: true
		}
	},
	{
		path: "/design2",
		name: "Design2",
		component: () => import('../views/Design2/Design.vue'),
		meta: {
			title: "私人定制",
			// auth: true
		}
	},
	{
		path: "/user",
		name: "User",
		component: () => import('../views/User/UserLayout.vue'),
		redirect: '/user/center',
		children: [{
				name: "Center",
				path: "center",
				component: () => import("../views/User/Center.vue"),
				meta: {
					title: "个人中心",
					auth: true
				}
			},
			{
				name: "Profile",
				path: "profile",
				component: () => import("../views/User/Profile.vue"),
				meta: {
					title: "个人信息",
					auth: true
				}
			},
			{
				name: "Statement",
				path: "statement",
				component: () => import("../views/User/Statement.vue"),
				meta: {
					title: "余额明细",
					auth: true
				}
			},
			{
				name: "Order",
				path: "order",
				component: () => import("../views/User/Order.vue"),
				meta: {
					title: "我的订单",
					auth: true
				}
			},
			{
				name: "FixingList",
				path: "fixing_list",
				component: () => import("../views/User/FixingList.vue"),
				meta: {
					title: "我的返修",
					auth: true
				}
			},
			{
				name: "OrderDetail",
				path: "orderdetail",
				component: () => import("../views/User/OrderDetail.vue"),
				meta: {
					title: "订单详情",
					auth: true
				}
			},
			{
				name: "Refund",
				path: "refund",
				component: () => import("../views/User/Refund.vue"),
				meta: {
					title: "退款维权",
					auth: true
				}
			},
			{
				name: "Address",
				path: "address",
				component: () => import("../views/User/Address.vue"),
				meta: {
					title: "地址管理",
					auth: true
				}
			},
			{
				name: "EditAddress",
				path: "editaddress",
				component: () => import("../views/User/EditAddress.vue"),
				meta: {
					title: "新增地址",
					auth: true
				}
			},
			{
				name: "Fixing",
				path: "fixing",
				component: () => import("../views/User/Fixing.vue"),
				meta: {
					title: "客户寄回",
					auth: true
				}
			},
			{
				name: "ApplyFixing",
				path: "apply_fixing",
				component: () => import("../views/User/ApplyFixing.vue"),
				meta: {
					title: "申请返修",
					auth: true
				}
			},
			{
				name: "FigureBodyList",
				path: "figure_body_list",
				component: () => import("../views/User/FigureBody/FigureBodyList.vue"),
				meta: {
					title: "量体数据",
					auth: true
				}
			},
			{
				name: "FigureBodyDetail",
				path: "figure_body_detail",
				component: () => import("../views/User/FigureBody/FigureBodyDetail.vue"),
				meta: {
					title: "数据编辑",
					auth: true
				}
			},

			{
				name: "Security",
				path: "security",
				component: () => import("../views/User/Security.vue"),
				meta: {
					title: "安全设置",
					auth: true
				}
			},
			{
				name: "PayPassword",
				path: "pay_password",
				component: () => import("../views/User/PayPassword.vue"),
				meta: {
					title: "支付密码设置",
					auth: true
				}
			},
			{
				name: "PointLog",
				path: "pointlog",
				component: () => import("../views/User/PointLog.vue"),
				meta: {
					title: "积分明细",
					auth: true
				}
			},
			{
				name: "Coupon",
				path: "coupon",
				component: () => import("../views/User/Coupon.vue"),
				meta: {
					title: "优惠券",
					auth: true
				}
			},

		]
	},
	{
		name: "FigureBodyForm",
		path: "/figure_body_form",
		component: () => import("../views/User/FigureBody/FigureBodyForm.vue"),
		meta: {
			title: "数据新增",
			auth: true
		}
	},
	{
		path: "/order_figure",
		name: "OrderFigure",
		component: () => import('../views/User/OrderFigure.vue'),
		meta: {
			title: "修改订单量体数据",
			auth: true
		}
	},
	{
		name: "Payment",
		path: "/payment",
		component: () => import("../views/Payment.vue"),
		meta: {
			title: "",
			auth: true
		}
	},
	{
		name: "Paytype",
		path: "/paytype",
		component: () => import("../views/Paytype.vue"),
		meta: {
			title: "付款方式",
			auth: true
		}
	},
	{
		path: "/category_detail",
		name: "CategoryDetail",
		component: () => import('../views/Category/Detail.vue'),
		meta: {
			title: "私人定制",
			auth: false
		}
	},
	{
		path: "/login",
		name: "Login",
		component: () => import('../views/Login.vue'),
		meta: {
			title: "登录",
			auth: false
		}
	},
]

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location){
  return originalPush.call(this, location).catch(err => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function(location){
  return originalReplace.call(this, location).catch(err => err);
};

const router = new VueRouter({
	mode: 'history',
	base: '/pc',
	routes
})
router.beforeEach((to, from, next) => {
	//检查是否加载了配置
	if (!state.getters.isSettingLoad()) {
		getSetting({}).then(response => {
			state.commit("updateSetting", response.data)
		})
	}
	// 检查登录状态
	if (to.matched.some(record => record.meta.auth)) {
		if (state.getters.isLoginDynamic()) {
			next()
		} else {
			state.commit('update_login_state', false)
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			})
		}
	} else {
		next()
	}
})

export default router
